import { Outlet } from 'react-router-dom'
import React, { Suspense, useEffect, useMemo, useRef, useState } from 'react'
import ButtonLoader from '../../CustomButton/ButtonLoader'
import { Box } from '@mui/material'
import {
  AccountTree,
  GridView,
  ViewStream,
  SpaceDashboard,
  ChecklistRtl,
  SupervisorAccount,
  Settings,
  Quiz,
  EmergencyShare,
  ToggleOn,
  Category,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Schema,
  Insights,
} from '@mui/icons-material'
import { Link, useLocation } from 'react-router-dom'
import { BigLogo } from '../../../../assets/images'
import { PermittedRoutes, getLocalStorage, getPermissions, homeScreenRedirection, naiFlowAuthTab, setLocalStorage } from '../../../../utils/helper'
import { useSidebar } from '../../../../context/SidebarContext'
import SmartLogo from '../../SmartLogo'

const SidebarLayout = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const { pathname } = useLocation()
  const isSmallScreen = useMemo(() => window.innerWidth < 640, [])
  const [isSidebarOpen, setIsSidebarOpen] = useState(getLocalStorage('sidebar') === 'false' || isSmallScreen ? false : true)
  const [hoveredRoute, setHoveredRoute] = useState('')
  const { expandedMenus, setExpandedMenus } = useSidebar()
  const selectedRoute = `/${pathname?.split('/')[1]}`

  const toggleSidebar = () => {
    setLocalStorage('sidebar', !isSidebarOpen)
    setIsSidebarOpen(!isSidebarOpen)
  }

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event?.target as any
      if (target?.id !== 'hamburger-img' && target?.id !== 'hamburger' && wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        // setLocalStorage('sidebar', false)
        setIsSidebarOpen(false)
      }
    }

    if (isSmallScreen) {
      document.addEventListener('click', handleOutsideClick)
    }

    return () => {
      if (isSmallScreen) {
        document.removeEventListener('click', handleOutsideClick)
      }
    }
  }, [isSmallScreen])
  const naiHubTabs = getPermissions()
    ?.filter((ls: any) => ls?.is_nai_hub)
    ?.map((tab: any) => `/dashboard/nai-hub/${tab?.module_name}/${tab?.slug}`)
  const sidebarLinks: any[] = [
    {
      path: naiFlowAuthTab,
      label: 'Organisation Dashboard',
      slug: 'dashboard',
      icon: <SpaceDashboard />,
      subMenu: [
        {
          path: '/dashboard/overview',
          label: 'Overview',
          slug: 'org-dashboard',
          icon: <GridView />,
        },
        {
          path: '/dashboard/nai-flow',
          label: 'nAI Flow',
          slug: 'nai-flow',
          icon: <GridView />,
        },

        {
          path: naiHubTabs[0] /** Hide for now will make it live in next sprint (Sprint-39) */,
          label: 'nAI Hub',
          slug: 'nai-hub',
          icon: <GridView />,
        },
        // {
        //   path: '/dashboard',
        //   label: 'Observation',
        //   slug: 'dashboard',
        //   icon: <GridView />,
        // },
        // TODO: Merge With Observation dashboard for now as confirmed with @Venky
        // {
        //   path: '/dashboard/site-walkthrough',
        //   label: 'Site Walkthrough',
        //   slug: 'site-walkthrough',
        //   icon: <GridView />,
        // },
        // {
        //   path: '/dashboard/statistics-capture',
        //   label: 'Statistics Capture',
        //   slug: 'statistics-capture',
        //   icon: <GridView />,
        // },
        // {
        //   path: '/dashboard/incident',
        //   label: 'Incident',
        //   slug: 'incident-dashboard',
        //   icon: <GridView />,
        // },
        // {
        //   path: '/dashboard/inspection',
        //   label: 'Inspection',
        //   slug: 'inspection-dashboard',
        //   icon: <GridView />,
        // },
        // {
        //   path: '/dashboard/trining',
        //   label: 'Training',
        //   slug: 'training-dashboard',
        //   icon: <GridView />,
        // },
      ],
    },

    {
      path: '/user-management/users',
      label: 'User Management',
      slug: 'user-management',
      icon: <SupervisorAccount />,
    },
    {
      path: '/quiz-assessment',
      label: 'Quiz Assessment',
      slug: 'quiz-assessment',
      icon: <Quiz />,
    },
    {
      path: '/video-script-generation',
      label: 'Video Script Generation',
      slug: 'video-script-generation',
      icon: <Category />,
    },
    {
      path: '/ai-insights',
      label: 'AI Insights Management',
      slug: 'ai-insights',
      icon: <Insights />,
    },
    {
      path: '/project-management',
      label: 'Project Management',
      slug: 'project-management',
      icon: <AccountTree />,
    },

    {
      path: '/workflow-builder',
      label: 'Workflow Builder',
      slug: 'workflow-builder',
      icon: <Schema />,
    },
    {
      path: '/masters',
      label: 'Masters',
      slug: 'master',
      icon: <Settings />,
      subMenu: [
        {
          path: '/masters',
          label: 'Division',
          slug: 'master',
          icon: <ViewStream />,
        },
        {
          path: '/masters/hazard-type',
          label: 'Hazard Type',
          slug: 'master',
          icon: <ChecklistRtl />,
        },
        {
          path: '/masters/root-cause',
          label: 'Root Cause',
          slug: 'master',
          icon: <Quiz />,
        },
        {
          path: '/masters/severity',
          label: 'Severity',
          slug: 'master',
          icon: <EmergencyShare />,
        },
        {
          path: '/masters/observation-status',
          label: 'Observation Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/statistics-capture-status',
          label: 'Statistics Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/statistics-capture-inputs',
          label: 'Statistics Inputs',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/incident-status',
          label: 'Incident Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/incident-category',
          label: 'Incident Category',
          slug: 'master',
          icon: <Category />,
        },
        {
          path: '/masters/incident-severity',
          label: 'Incident Severity',
          slug: 'master',
          icon: <EmergencyShare />,
        },
        // Inspection's Master
        {
          path: '/masters/inspection-status',
          label: 'Ins. Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/inspection-schedule-status',
          label: 'Ins. Schedule Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/inspection-non-conformance-status',
          label: 'Ins. NC Status',
          slug: 'master',
          icon: <ToggleOn />,
        },
        {
          path: '/masters/inspection-Topic',
          label: 'Ins. Topic',
          slug: 'master',
          icon: <ChecklistRtl />,
        },
        {
          path: '/masters/inspection-sub-category',
          label: 'Ins. Sub Category',
          slug: 'master',
          icon: <Category />,
        },
        {
          path: '/masters/inspection-questions',
          label: 'Ins. Questions',
          slug: 'master',
          icon: <Category />,
        },
        {
          path: '/masters/training-category',
          label: 'Training Category',
          slug: 'master',
          icon: <Category />,
        },
      ],
    },
  ]

  const handleHover = (path?: string) => {
    if (path) {
      if (path !== hoveredRoute) {
        setHoveredRoute(path)
      }
    } else if (hoveredRoute) {
      setHoveredRoute('')
    }
  }
  const handleLinkClick = () => {
    if (isSmallScreen) {
      setIsSidebarOpen(false)
    }
  }
  return (
    <div className="flex h-screen w-full">
      <Box
        bgcolor={'secondary.main'}
        ref={wrapperRef}
        className={` z-[1] py-4 transition-all duration-300 ease-in-out md:relative absolute h-full border-r-2 border-borderGray ${
          isSidebarOpen ? 'w-[270px] px-4' : 'md:w-[76px] w-0 md:px-4 px-0 '
        }`}
      >
        <button onClick={toggleSidebar} className="text-white focus:outline-none absolute top-[95px] left-full -translate-x-2/4 border-2 border-borderGray rounded-[50%]">
          <div className={`rounded-full p-1 bg-white text-black transition-all duration-300 ease-in-out hidden md:block ${isSidebarOpen ? 'rotate-180' : ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
          </div>
        </button>
        <ul className="text-white overflow-hidden ">
          <div className="flex justify-between px-2 overflow-hidden">
            <Link to={homeScreenRedirection()} className="!no-underline">
              <SmartLogo src={BigLogo} />
            </Link>
            <div className={`md:hidden cursor-pointer ${isSidebarOpen ? 'block delay-700' : 'hidden'}`} onClick={toggleSidebar}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </div>
            <span className="sr-only">close</span>
          </div>
          <div className="max-h-[calc(100vh-100px)] overflow-y-auto no-scrollbar">
            {PermittedRoutes(sidebarLinks)?.map((link: any, index: number) => (
              <React.Fragment key={index}>
                {link?.subMenu?.length ? (
                  <div>
                    <li className="mb-2 flex items-center" onMouseEnter={() => handleHover(link.path)} onMouseLeave={() => handleHover()}>
                      <Link onClick={handleLinkClick} to={link.path} className="w-full">
                        <Box
                          sx={{
                            bgcolor:
                              selectedRoute === link?.path ||
                              pathname === link?.path ||
                              selectedRoute?.includes(link.path) ||
                              pathname?.includes(link.path) ||
                              link.path?.includes(selectedRoute) ||
                              link.path?.includes(pathname) ||
                              hoveredRoute?.includes(link.path)
                                ? 'primary.main'
                                : '',
                            color:
                              (pathname === selectedRoute) === link?.path ||
                              pathname === link?.path ||
                              selectedRoute?.includes(link.path) ||
                              pathname?.includes(link.path) ||
                              link.path?.includes(selectedRoute) ||
                              link.path?.includes(pathname) ||
                              hoveredRoute?.includes(link.path)
                                ? 'secondary.main'
                                : 'primary.main',
                            '&:hover': {
                              bgcolor: 'primary.main',
                              color: 'secondary.main',
                            },
                          }}
                          className={`!no-underline flex focus:outline-none text-black hover:text-white w-full w hover:bg-secondary px-2 py-3 rounded-lg items-center justify-between gap-x-2`}
                        >
                          <span className="flex items-center">
                            <div>{link.icon}</div>
                            <span className={`text-sm whitespace-nowrap font-[500] ml-[14px] ${isSidebarOpen ? '' : ' delay-700 transition-all duration-500 ease-in'}`}>
                              {link.label}
                            </span>
                          </span>

                          <span
                            onClick={(e: any) => {
                              e.preventDefault()
                              if (expandedMenus?.includes(link?.slug)) {
                                setExpandedMenus(expandedMenus?.filter((slug: any) => slug !== link?.slug))
                              } else {
                                setExpandedMenus([...expandedMenus, link?.slug])
                              }
                            }}
                          >
                            {expandedMenus?.includes(link?.slug) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                          </span>
                        </Box>
                      </Link>
                    </li>
                    {expandedMenus?.includes(link?.slug)
                      ? PermittedRoutes(link?.subMenu)?.map((subLink: any, key: number) => (
                          <li key={key} className="mb-2 flex items-center" onMouseEnter={() => handleHover(subLink.path)} onMouseLeave={() => handleHover()}>
                            <Link onClick={handleLinkClick} to={subLink.path} className="w-full">
                              <Box
                                sx={{
                                  bgcolor: pathname === subLink.path ? 'primary.main' : '',
                                  color: pathname === subLink.path ? 'secondary.main' : 'primary.main',
                                  '&:hover': {
                                    bgcolor: 'primary.main',
                                    color: 'secondary.main',
                                  },
                                }}
                                className={`!no-underline flex focus:outline-none hover:text-secondary w-full w  px-2 py-3 rounded-lg items-center gap-x-2`}
                              >
                                <div
                                  className={`flex items-center text-sm whitespace-nowrap font-[500] ${isSidebarOpen ? 'pl-9 ml-1.5' : ' delay-100 transition-all duration-500 ease-in'}`}
                                >
                                  {subLink.icon}
                                  <span className="ml-4">{subLink.label}</span>
                                </div>
                              </Box>
                            </Link>
                          </li>
                        ))
                      : null}
                  </div>
                ) : (
                  <li className="mb-2 flex items-center" onMouseEnter={() => handleHover(link.path)} onMouseLeave={() => handleHover()}>
                    <Link onClick={handleLinkClick} to={link.path} className="w-full">
                      <Box
                        sx={{
                          bgcolor: ('/user-management' === selectedRoute && link?.path?.includes(selectedRoute)) || selectedRoute === link.path ? 'primary.main' : '',
                          color: ('/user-management' === selectedRoute && link?.path?.includes(selectedRoute)) || selectedRoute === link.path ? 'secondary.main' : 'primary.main',
                          '&:hover': {
                            bgcolor: 'primary.main',
                            color: 'secondary.main',
                          },
                        }}
                        className={`!no-underline flex focus:outline-none text-black hover:text-white w-full w hover:bg-secondary px-2 py-3 rounded-lg items-center gap-x-2`}
                      >
                        <div>{link.icon}</div>
                        <span className={`text-sm whitespace-nowrap font-[500] ml-1.5 ${isSidebarOpen ? '' : ' delay-700 transition-all duration-500 ease-in'}`}>{link.label}</span>
                      </Box>
                    </Link>
                  </li>
                )}
              </React.Fragment>
            ))}
          </div>
        </ul>
      </Box>
      <div className="flex-1 h-[100vh] max-w-screen">
        <Suspense fallback={
          <div className="h-full w-full flex items-center justify-center relative">
            <ButtonLoader fullScreen={true} />
          </div>
        }>
          <Outlet />
        </Suspense>
      </div>
    </div>
  )
}

export default SidebarLayout
